import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useLang();

  const SITE_LINKS = [
    { to: "/", label: t("nav_home") },
    { to: "/liberty", label: t("nav_liberty") },
    { to: "/partner", label: t("nav_partner") },
    { to: "/contatti", label: t("nav_contatti") },
  ];

  const LEGAL_LINKS = [
    { to: "/legali/informazioni-societarie", label: t("foot_legal_soc"), testid: "footer-link-informazioni-societarie" },
    { to: "/legali/informativa-rischi", label: t("foot_legal_rischi"), testid: "footer-link-informativa-sui-rischi" },
    { to: "/legali/privacy", label: t("foot_legal_privacy"), testid: "footer-link-privacy" },
    { to: "/legali/termini", label: t("foot_legal_termini"), testid: "footer-link-termini" },
  ];

  return (
    <footer data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-10">
        <p className="text-sm leading-relaxed text-ink-muted border border-pine/15 bg-surface px-6 py-5" data-testid="risk-disclaimer">
          {t("disclaimer")}
        </p>
      </div>
      <div className="bg-pine text-cream">
        <div className="h-px w-full bg-gold/40" aria-hidden="true" />
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid gap-12 md:grid-cols-4">
          <div>
            <Logo tone="cream" size="text-4xl" />
            <p className="text-[0.6rem] font-semibold uppercase tracking-[0.32em] text-cream/60 mt-3">
              Capital &amp; Partners
            </p>
            <p className="mt-6 text-sm text-cream/70 leading-relaxed">
              {t("foot_tagline")}
            </p>
          </div>
          <nav aria-label="Liberty">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold mb-5">{t("foot_col_site")}</p>
            <ul className="space-y-3">
              {SITE_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-cream/80 hover:text-gold transition-colors" data-testid={`footer-link-${l.to === "/" ? "home" : l.to.slice(1)}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Accesso">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold mb-5">{t("foot_col_accesso")}</p>
            <ul className="space-y-3">
              <li>
                <Link to="/accedi" className="text-sm text-cream/80 hover:text-gold transition-colors" data-testid="footer-link-accedi">
                  {t("nav_accedi")}
                </Link>
              </li>
              <li>
                <Link to="/accedi?mode=registrati" className="text-sm text-cream/80 hover:text-gold transition-colors" data-testid="footer-link-richiedi-accesso">
                  {t("nav_richiedi")}
                </Link>
              </li>
            </ul>
          </nav>
          <nav aria-label="Legali">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold mb-5">{t("foot_col_legali")}</p>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-cream/80 hover:text-gold transition-colors" data-testid={l.testid}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className="border-t border-cream/10">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
            <p className="text-xs text-cream/50">© {new Date().getFullYear()} {t("foot_rights")}</p>
            <p className="text-xs text-cream/50">libertycp.net</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
